export function filterData(key, data, filterString) {
  if (!key || !data || !filterString) {
    return [];
  }

  return data.filter(
    (item) => item[key] && item[key].toString().toLowerCase().includes(filterString.toLowerCase())
  );
}
